export const HANDLE_TYPE_PRICE_LINK_LOADING = 'LINK_TABLE/HANDLE_TYPE_PRICE_LINK_LOADING';
export const SET_TYPE_PRICE_LINK = 'LINK_TABLE/SET_TYPE_PRICE_LINK';